import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"
import { Component, Input } from "@angular/core"

@Component({
    selector: "app-information-modal",
    templateUrl: "./information-modal.component.html",
    styleUrls: ["./information-modal.component.less"],
})
export class InformationModalComponent {
    @Input() message: string

    constructor(public activeModal: NgbActiveModal) {}
}
